module.exports = __webpack_public_path__ + "static/media/score_retrieve.d7b670a1.svg";